import React, { useState, useEffect, useContext } from "react";
import * as FaIcons from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import states from "../../data/states";
import residencyCountries from "../../data/residencyCountries";
import residencyDistrict from "../../data/residencyDistrict";
import livingStatusList from "../../data/livingStatusList";
import leloContext from "../../context/leloreg/leloContext";
import { toast } from "react-toastify";

const R4PhysicalAddress = () => {
  const LeloContext = useContext(leloContext);
  const navigate = useNavigate();
  const {
    formData: {
      firstName,
      liveWithPg,
      livingStatus,
      street,
      city,
      state,
      zip,
      country,
      district,
      isMailingAddressTheSame,
      charter,
      charter_id,
    },
    onFormDataChange,
    pass: { physical },
  } = LeloContext;
  const [FormSubmit, setFormSubmit] = useState(false);
  const [districtOptions, setDistrictOptions] = useState([]);
  const location = useLocation();
  const { _uuid, pgRelationshipToStudent, LeloRegistrationProfile, _id, permalink } = location.state || {};
//Return to Start if formData.Charter is missing

  // useEffect(() => {
  //   if (!charter_id) {
  //     alert("Something went wrong");
      
  
  //     if (_uuid === undefined) {
  //       history.push(`/forms/${permalink}/${_id}`);
  //     } else {
  //       history.push(`/forms/${permalink}/${_uuid}/${LeloRegistrationProfile}`);
  //     }
  //   }
  // }, [charter_id, history, permalink, LeloRegistrationProfile, _id, _uuid]);
  
  
  useEffect(() => {
    if (!charter_id) {
      toast.error("Something went wrong");
      if (_uuid === undefined) {
        navigate(`/forms/${permalink}`);
      } else {
        navigate(`/forms/${permalink}/${_uuid}`);
      }
    }
  }, [charter_id, navigate, permalink, LeloRegistrationProfile, _id, _uuid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "street" || name === "city") {
      onFormDataChange({
        target: {
          name,
          value: value
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" "),
        },
      });
    } else {
      onFormDataChange(e);
    }
    if (name === "country") {
      // Update the district options based on the selected country
      const selectedCountry = value;
      if (residencyDistrict[selectedCountry]) {
        setDistrictOptions(residencyDistrict[selectedCountry]);
      } else {
        setDistrictOptions([]); // Clear the district options if no districts are found
      }
    }
  };

  const validateZipCode = (zip) => {
    const re = /^\d{5}$/;
    return re.test(String(zip));
  };

  const handleZipChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 5) {
      onFormDataChange({
        target: {
          name: "zip",
          value: value,
        },
      });
    }
  };

  const physicalFilledOut =
    liveWithPg &&
    livingStatus &&
    street &&
    city &&
    state &&
    country &&
    zip &&
    validateZipCode(zip) &&
    district &&
    isMailingAddressTheSame;

  const handleSubmit = () => {
    setFormSubmit(true); // Mark the form as submitted
    if (physicalFilledOut) {
      if (isMailingAddressTheSame["yes"]) {
        navigate("/leloStudent4", { state: { permalink, _uuid, pgRelationshipToStudent, _id, LeloRegistrationProfile } }); // Push to Student4 if Yes
      } else {
        navigate("/leloStudent3", { state: { permalink, _uuid, pgRelationshipToStudent, _id, LeloRegistrationProfile } }); // Push to Student3 if No
      }
    }
  };

  // Helper function to get CSS class for form validation
  const getInputClassName = (value) => {
    if (FormSubmit && !value) {
      return "form-field-error";
    }
    return "form-field-default";
  };

  // Helper function for radio button container validation
  const getRadioContainerClassName = (value) => {
    if (FormSubmit && !value) {
      return "flex-check-container radio-container-error";
    }
    return "flex-check-container radio-container-default";
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Changes you made may not be saved.";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);  

  useEffect(() => {
    if (country) {
      // If there's already a country selected, set the district options accordingly
      const selectedCountry = country;
      if (residencyDistrict[selectedCountry]) {
        setDistrictOptions(residencyDistrict[selectedCountry]);
      }
    }
  }, [country]);

  return (
    <div className="sub-form">
      <h2>
        Physical Address <span>(4/7)</span> <hr />
      </h2>
      <div className="item">
        <div className="asterisk-group">
          <h3>Does {firstName || "the Student"} Live with Parents?</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <div className={getRadioContainerClassName(liveWithPg)}>
          <label className="check-container radio-label">
            Yes
            <input
              type="radio"
              value="yes"
              checked={liveWithPg === "yes"}
              onChange={(e) =>
                onFormDataChange({ target: { name: "liveWithPg", value: e.target.value } })
              }
              name="liveWithPg"
            />
            <span className="styled-checkmark"></span>
          </label>
          <label className="check-container radio-label">
            No
            <input
              type="radio"
              value="no"
              checked={liveWithPg === "no"}
              onChange={(e) =>
                onFormDataChange({ target: { name: "liveWithPg", value: e.target.value } })
              }
              name="liveWithPg"
            />
            <span className="styled-checkmark"></span>
          </label>
        </div>
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>What is {firstName + "'s" || "the Student"} Living Status?</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <select
          name="livingStatus"
          value={livingStatus}
          onChange={handleChange}
          className={getInputClassName(livingStatus)}
        >
          <option value="">Please Select</option>
          {livingStatusList.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>Street</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <input
          type="text"
          name="street"
          maxLength="100"
          onChange={handleChange}
          value={street}
          className={getInputClassName(street)}
        />
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>City</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <input
          type="text"
          name="city"
          maxLength="100"
          onChange={handleChange}
          value={city}
          className={getInputClassName(city)}
        />
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>State</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <select
          name="state"
          value={state}
          onChange={handleChange}
          className={getInputClassName(state)}
        >
          <option value="">Please Select</option>
          {states.map((item) => (
            <option key={Object.keys(item)[0]} value={Object.keys(item)[0]}>
              {Object.keys(item)[0]}
            </option>
          ))}
        </select>
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>Zip</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <input
          type="text"
          name="zip"
          maxLength="5"
          onChange={handleZipChange}
          value={zip}
          className={getInputClassName(zip)}
        />
        {zip && !validateZipCode(zip) && (
          <p className="validEmail">Please provide a valid Zip/Postal Code</p>
        )}
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>County of Residence</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <select
          name="country"
          value={country}
          onChange={handleChange}
          className={getInputClassName(country)}
        >
          <option value="">Please Select</option>
          {residencyCountries.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>School District of Residence</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <select
          name="district"
          value={district}
          onChange={handleChange}
          className={getInputClassName(district)}
        >
          <option value="">Please Select</option>
          {districtOptions.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      <div className="item">
        <div className="asterisk-group">
          <h3>Is Mailing Address the Same?</h3>
          <FaIcons.FaAsterisk className="asterisk-icon" />
        </div>
        <div className={getRadioContainerClassName(isMailingAddressTheSame)}>
          <label className="check-container radio-label">
            Yes
            <input
              type="radio"
              value="yes"
              checked={isMailingAddressTheSame["yes"]}
              onChange={(e) => handleChange(e)}
              name="isMailingAddressTheSame"
            />
            <span className="styled-checkmark"></span>
          </label>
          <label className="check-container radio-label">
            No
            <input
              type="radio"
              value="no"
              checked={isMailingAddressTheSame["no"]}
              onChange={(e) => handleChange(e)}
              name="isMailingAddressTheSame"
            />
            <span className="styled-checkmark"></span>
          </label>
        </div>
      </div>

      <div className="progress-btns">
        <div className="circle-btn" onClick={() => navigate(-1)}>
          <FaIcons.FaChevronLeft className="progress-level-btn" />
        </div>

        <div className="circle-btn" onClick={handleSubmit}>
          <FaIcons.FaChevronRight className="progress-level-btn" />
        </div>
      </div>
    </div>
  );
};

export default R4PhysicalAddress;